import { Button, Modal, Space, Switch } from "antd"
import { useState } from "react"
import { faRotate } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VSpace from "../../../../common/VSpace"
import { Workarea } from "../../../../../domain/job"
import { useSyncRecurringWorkareasMutation } from "../../../../../domain/workareas/workareaQueries"

export type Props = {
  workarea: Workarea
}

const SyncRecurringWorkareas = ({workarea}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [removeNonMatchingItems, setRemoveNonMatchingItems] = useState(false)

  const mutation = useSyncRecurringWorkareasMutation(() => setIsModalOpen(false))

  const icon = <FontAwesomeIcon icon={faRotate} />

  return <>
    <Button size="large" onClick={() => setIsModalOpen(true)}>
      <Space>{icon} Sync</Space>
    </Button>

    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      title={<Space style={{fontSize: '1.2em'}}>{icon} Sync Recurring Workareas</Space>}
      okText="Update"
      onOk={() => {
        mutation.mutate({
          jobId: workarea.jobId,
          masterWorkareaId: workarea.id,
          removeNonMatchingItems
        })
      }}
      okButtonProps={{
        loading: mutation.isLoading,
        disabled: mutation.isLoading
      }}
      cancelButtonProps={{
        disabled: mutation.isLoading
      }}
    >
      <VSpace>
        <span>This will update all related workareas to match this one.</span>
        <span>Select whether you want to keep or remove items in the other tasks which do not match:</span>
        <Space>
          <Switch checked={removeNonMatchingItems} onChange={setRemoveNonMatchingItems}/> Remove non-matching items
        </Space>
      </VSpace>
    </Modal>
  </>
}

export default SyncRecurringWorkareas